module.exports = __webpack_public_path__ + "static/media/tick.cb196641.svg";